import { UpdateCartQuantityAction } from './types';

export const UPDATE_CART_QUANTITY = 'UPDATE_CART_QUANTITY';

export const updateCartItemsQuantity = (
  quantity: number
): UpdateCartQuantityAction => ({
  type: UPDATE_CART_QUANTITY,
  quantity: quantity
});
